import TableHeadCell from "./TableHeadCell.jsx";

/**
 * @param {object} props
 * @param {Array<object>} [props.columns]
 * @param {Array<Array<object>>} [props.headerRows] - Multi-row headers; a column in any row sorts as soon as it declares `sortable` and a `key`
 * @param {{key: string|null, direction: 'asc'|'desc'|null}} [props.sort] - Which column is sorted, and how
 * @param {(columnKey: string) => void} [props.onSort] - Called with the clicked column's key
 */
const TableHeader = ({ columns = [], headerRows = null, sort = null, onSort }) => {
  const rows = headerRows || [columns];

  return (
    <thead className="common-table__head">
      {rows.map((row, rowIndex) => (
        <tr key={`table-header-row-${rowIndex}`} className="common-table__head-row">
          {row.map((column, columnIndex) => {
            const sortable = Boolean(column.sortable && onSort && column.key);

            return (
              <TableHeadCell
                key={column.key || `${rowIndex}-${columnIndex}`}
                label={column.label}
                className={column.headerClassName}
                colSpan={column.colSpan}
                rowSpan={column.rowSpan}
                sortable={sortable}
                sortDirection={sort?.key === column.key ? sort.direction : null}
                onSort={sortable ? () => onSort(column.key) : undefined}
              >
                {column.headerContent}
              </TableHeadCell>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};

export default TableHeader;
